import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [siteInfo, setSiteInfo] = useState({
    name: "ctb28.fr",
    title: "La tranquillité pour vos travaux"
  });

  useEffect(() => {
    const loadSiteInfo = async () => {
      try {
        const response = await axios.get(`${API}/public/contact-info`);
        setSiteInfo({
          name: response.data.name || "ctb28.fr",
          title: response.data.title || "Consultant Travaux et Rénovation"
        });
      } catch (error) {
        console.error("Erreur lors du chargement des informations du site:", error);
      }
    };
    loadSiteInfo();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-1">
          <div className="flex-shrink-0">
            <div className="flex items-center space-x-3">
              <img 
                src="/ctb28-logo.png" 
                alt="CTB28 Logo" 
                className="h-10 w-auto"
              />
              <h1 className="text-sm md:text-base font-light text-blue-700 tracking-wide italic" style={{fontFamily: 'cursive'}}>
                La tranquillité pour vos travaux
              </h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection("accueil")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection("a-propos")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              À propos
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("tarifs")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              Tarifs
            </button>
            <button
              onClick={() => scrollToSection("realisations")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              Réalisations
            </button>

            <button
              onClick={() => scrollToSection("contact")}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium"
            >
              Contact
            </button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-900 transition-colors duration-200"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col space-y-2">
              <button
                onClick={() => scrollToSection("accueil")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                Accueil
              </button>
              <button
                onClick={() => scrollToSection("a-propos")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                À propos
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("tarifs")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                Tarifs
              </button>
              <button
                onClick={() => scrollToSection("realisations")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                Réalisations
              </button>

              <button
                onClick={() => scrollToSection("contact")}
                className="text-left text-gray-700 hover:text-blue-900 transition-colors duration-200 font-medium py-2"
              >
                Contact
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;